module.exports = __webpack_public_path__ + "img/Mejores-Empresas.7257cf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img_link/Mejores-Empresas.png
// module id = 05mY
// module chunks = 1